import React, { useContext } from "react";
import "./Info.scss";
import { I18nContext } from "../../context";

/**
 * Info block with link to platform
 * @param {Object} props
 * @param {String} props.url Platform URL
 * @returns {React.ReactElement}
 */
function Info({ url }) {
  const { locale } = useContext(I18nContext);

  return (
    <div className="Info">
      <div className="Info__inner">
        <h3 className="Info__title">{locale.infoTitle}</h3>
        <p className="Info__text">{locale.infoText}</p>
        <a className="Info__link" href={url}>
          {locale.infoLinkLabel}
        </a>
      </div>
    </div>
  );
}

export default Info;
